const HISTORY_CACHE_BROADCAST_CHANNEL = 'issen-history-cache';

export type HistoryCacheBroadcastMessage = {
  type: 'clear';
  sourceId: string;
};

export interface HistoryCacheBroadcastAdapter {
  publish(message: HistoryCacheBroadcastMessage): void;
  subscribe(listener: (message: HistoryCacheBroadcastMessage) => void): () => void;
  close(): void;
}

class NativeHistoryCacheBroadcast implements HistoryCacheBroadcastAdapter {
  private readonly listeners = new Set<(message: HistoryCacheBroadcastMessage) => void>();

  constructor(private readonly channel: BroadcastChannel) {
    this.channel.onmessage = (event: MessageEvent<unknown>) => {
      const message = event.data;
      if (
        message === null
        || typeof message !== 'object'
        || !('type' in message)
        || message.type !== 'clear'
        || !('sourceId' in message)
        || typeof message.sourceId !== 'string'
      ) {
        return;
      }
      for (const listener of this.listeners) {
        listener(message as HistoryCacheBroadcastMessage);
      }
    };
  }

  publish(message: HistoryCacheBroadcastMessage): void {
    this.channel.postMessage(message);
  }

  subscribe(listener: (message: HistoryCacheBroadcastMessage) => void): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  close(): void {
    this.listeners.clear();
    this.channel.close();
  }
}

export const createBrowserHistoryCacheBroadcast = (): HistoryCacheBroadcastAdapter | null => {
  if (typeof globalThis.BroadcastChannel !== 'function') {
    return null;
  }
  return new NativeHistoryCacheBroadcast(
    new globalThis.BroadcastChannel(HISTORY_CACHE_BROADCAST_CHANNEL),
  );
};
